import { useEffect, useState } from 'react';

export default function useIncrementingCount({
  startCount,
  getCurrentCount,
  updateInteval = 1000,
}: {
  startCount: number;
  getCurrentCount: () => number;
  updateInteval?: number;
}) {
  const [count, setCount] = useState(startCount);
  const [displayedCount, setDisplayedCount] = useState(startCount);

  useEffect(() => {
    const tweenStartTime = Date.now();
    const delta = count - displayedCount;
    const startCountForStep = displayedCount;

    const interval = setInterval(() => {
      const timeDiff = Date.now() - tweenStartTime;
      const progress = Math.min(1, timeDiff / updateInteval);
      const increment = Math.round(delta * progress);
      setDisplayedCount(startCountForStep + increment);

      if (progress >= 1 || displayedCount === count) {
        clearInterval(interval);
      }
    }, 20);

    return () => clearInterval(interval);
  }, [count]);

  useEffect(() => {
    const interval = setInterval(() => {
      const newCount = getCurrentCount();
      setCount(newCount);
    }, updateInteval);

    return () => clearInterval(interval);
  }, []);

  return displayedCount;
}
